import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  content: null,
  isOpenContentsModal: false,
};

const contentSlice = createSlice({
  name: "content",
  initialState,
  reducers: {
    setContent: (state, action) => {
      state.content = action.payload;
    },
    setIsOpenContentsModal: (state, action) => {
      state.isOpenContentsModal = action.payload;
    },
  },
});

export const { setContent, setIsOpenContentsModal, setIsOpenContents } =
  contentSlice.actions;
export default contentSlice.reducer;
